import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseWidget from '../../components/common/BaseWidget'
import EngagementWidget from '../../components/common/EngagementWidget/EngagementWidget'
import { useFetchPatientsSentimentAggregationQuery } from 'store/modules/CopilotControl'
import useCopilotAccountOwnerId from '../../hooks/useCopilotAccountOwnerId'
import { CopilotEngagementTypes } from 'consts/copilotControlConsts'

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1
  }
}))

const PatientsSentiment = ({ onChangePatientsListType, isSelected }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const accountOwnerId = useCopilotAccountOwnerId()

  const { data: sentimentData = {}, isLoading } = useFetchPatientsSentimentAggregationQuery(
    { accountOwnerId },
    { skip: !accountOwnerId }
  )

  return (
    <BaseWidget carousel={false} className={classes.root} isSelected={isSelected} removePadding>
      <EngagementWidget
        isLoading={isLoading}
        title={t('pages.copilotControl.widgets.patientsSentiment.title')}
        values={sentimentData}
        engagementType={CopilotEngagementTypes.PatientsSentiment}
        onChangePatientsListType={onChangePatientsListType}
      />
    </BaseWidget>
  )
}

export default PatientsSentiment
